module.exports = __webpack_public_path__ + "static/media/NFTs CC-02.c4da98bd.png";